// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Roboto-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Roboto-ThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Roboto-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/Roboto-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/Roboto-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/Roboto-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/fonts/Roboto-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/fonts/Roboto-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/fonts/Roboto-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Roboto";
  font-weight: 100;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 100;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 300;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 300;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 400;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 400;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 500;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 500;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 700;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 700;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 900;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 900;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype");
}
.dateStrip {
  padding: 0.75rem 0 0;
}
.dateStrip__header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  margin: 0 0 0.5rem;
}
.dateStrip__month {
  min-width: 8rem;
  font-size: 0.82rem;
  font-weight: 600;
  text-align: center;
  text-transform: capitalize;
  color: rgb(80, 80, 80);
}
.dateStrip__nav {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  background-color: #ffffff;
  border: none;
  border-radius: 50%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  color: #515592;
  cursor: pointer;
  transition: background-color 0.15s ease, box-shadow 0.15s ease;
}
.dateStrip__nav:active:not(:disabled) {
  box-shadow: 0 0.125rem 0.5rem #363c56;
  transform: translateY(0.125rem);
  opacity: 0.75;
}
.dateStrip__nav:hover {
  background-color: rgba(81, 85, 146, 0.08);
}
.dateStrip__scroller {
  position: relative;
  display: flex;
  gap: 0.6rem;
  padding: 0.25rem 1rem 0.75rem;
  overflow-x: auto;
  scroll-snap-type: x proximity;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.dateStrip__scroller::-webkit-scrollbar {
  display: none;
}
.dateStrip__day {
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  width: 3rem;
  height: 3.75rem;
  background-color: #ffffff;
  border: none;
  border-radius: 1rem;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
  scroll-snap-align: start;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}
.dateStrip__day:active:not(:disabled) {
  box-shadow: 0 0.125rem 0.5rem #363c56;
  transform: translateY(0.125rem);
  opacity: 0.75;
}
.dateStrip__day:hover:not(:disabled):not(.dateStrip__day--selected) {
  background-color: rgba(81, 85, 146, 0.08);
}
.dateStrip__day--today:not(.dateStrip__day--selected) {
  box-shadow: inset 0 0 0 1.5px rgba(81, 85, 146, 0.4);
}
.dateStrip__day--selected {
  background-color: #515592;
  box-shadow: 0 6px 16px rgba(81, 85, 146, 0.35);
}
.dateStrip__day--selected .dateStrip__weekday {
  color: rgba(255, 255, 255, 0.75);
}
.dateStrip__day--selected .dateStrip__number {
  color: #ffffff;
}
.dateStrip__day:disabled {
  background-color: transparent;
  box-shadow: none;
  cursor: default;
  opacity: 0.3;
  pointer-events: none;
}
.dateStrip__weekday {
  font-size: 0.6rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: rgb(80, 80, 80);
  opacity: 0.55;
}
.dateStrip__number {
  font-size: 1rem;
  font-weight: 600;
  color: rgb(80, 80, 80);
}`, "",{"version":3,"sources":["webpack://./src/assets/Theme/variables/_fonts.scss","webpack://./src/components/Calendar/Calendar.scss","webpack://./src/assets/Theme/variables/_colorSchema.scss","webpack://./src/assets/Theme/mixins/_click-animation.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACCF;ADEA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACAF;ADGA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACDF;ADIA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACFF;ADKA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACHF;ADMA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACJF;ADOA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACLF;ADQA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACNF;ADSA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACPF;ADUA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACRF;ADWA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gEAAA;ACTF;ADYA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gEAAA;ACVF;AAnEA;EACE,oBAAA;AAqEF;AAnEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AAqEJ;AAlEE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;EACA,sBCZa;ADgFjB;AAjEE;EAEE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,yBChCI;EDiCJ,YAAA;EACA,kBAAA;EACA,yCAAA;EACA,cAlCY;EAmCZ,eAAA;EACA,8DACE;AAiEN;AEvGE;EACE,qCAAA;EACA,+BAAA;EACA,aAAA;AFyGJ;AAnEI;EACE,yCAAA;AAqEN;AAjEE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,6BAAA;EACA,gBAAA;EACA,6BAAA;EACA,uBAAA;EACA,iCAAA;EAMA,qBAAA;AA8DJ;AAlEI;EACE,aAAA;AAoEN;AA9DE;EAEE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,yBC1EI;ED2EJ,YAAA;EACA,mBAAA;EACA,0CAAA;EACA,wBAAA;EACA,eAAA;EACA,gFACE;AA8DN;AE9IE;EACE,qCAAA;EACA,+BAAA;EACA,aAAA;AFgJJ;AA/DI;EACE,yCAAA;AAiEN;AA9DI;EACE,oDAAA;AAgEN;AA7DI;EACE,yBA5FU;EA6FV,8CAAA;AA+DN;AA7DM;EACE,gCAAA;AA+DR;AA5DM;EACE,cCtGA;ADoKR;AA1DI;EACE,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;AA4DN;AAxDE;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBC/Ga;EDgHb,aAAA;AA0DJ;AAvDE;EACE,eAAA;EACA,gBAAA;EACA,sBCtHa;AD+KjB","sourcesContent":["@font-face {\n  font-family: 'Roboto';\n  font-weight: 100;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Thin.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 100;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-ThinItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 300;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Light.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 300;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-LightItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 400;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Regular.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 400;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-Italic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 500;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Medium.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 500;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-MediumItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 700;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Bold.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 700;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-BoldItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 900;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Black.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 900;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-BlackItalic.ttf') format('truetype');\n}\n","@import '../../assets/Theme/';\n\n$brand_primary: #515592;\n\n.dateStrip {\n  padding: 0.75rem 0 0;\n\n  &__header {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.75rem;\n    margin: 0 0 0.5rem;\n  }\n\n  &__month {\n    min-width: 8rem;\n    font-size: 0.82rem;\n    font-weight: 600;\n    text-align: center;\n    text-transform: capitalize;\n    color: $unselectedText;\n  }\n\n  &__nav {\n    @include click-animation;\n    display: flex;\n    flex-shrink: 0;\n    align-items: center;\n    justify-content: center;\n    width: 1.75rem;\n    height: 1.75rem;\n    background-color: $white;\n    border: none;\n    border-radius: 50%;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);\n    color: $brand_primary;\n    cursor: pointer;\n    transition:\n      background-color 0.15s ease,\n      box-shadow 0.15s ease;\n\n    &:hover {\n      background-color: rgba($brand_primary, 0.08);\n    }\n  }\n\n  &__scroller {\n    position: relative;\n    display: flex;\n    gap: 0.6rem;\n    padding: 0.25rem 1rem 0.75rem;\n    overflow-x: auto;\n    scroll-snap-type: x proximity;\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n\n    scrollbar-width: none;\n  }\n\n  &__day {\n    @include click-animation;\n    display: flex;\n    flex-shrink: 0;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 0.25rem;\n    width: 3rem;\n    height: 3.75rem;\n    background-color: $white;\n    border: none;\n    border-radius: 1rem;\n    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);\n    scroll-snap-align: start;\n    cursor: pointer;\n    transition:\n      background-color 0.15s ease,\n      color 0.15s ease,\n      box-shadow 0.15s ease;\n\n    &:hover:not(:disabled):not(&--selected) {\n      background-color: rgba($brand_primary, 0.08);\n    }\n\n    &--today:not(&--selected) {\n      box-shadow: inset 0 0 0 1.5px rgba($brand_primary, 0.4);\n    }\n\n    &--selected {\n      background-color: $brand_primary;\n      box-shadow: 0 6px 16px rgba(81, 85, 146, 0.35);\n\n      .dateStrip__weekday {\n        color: rgba(255, 255, 255, 0.75);\n      }\n\n      .dateStrip__number {\n        color: $white;\n      }\n    }\n\n    &:disabled {\n      background-color: transparent;\n      box-shadow: none;\n      cursor: default;\n      opacity: 0.3;\n      pointer-events: none;\n    }\n  }\n\n  &__weekday {\n    font-size: 0.6rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.02em;\n    color: $unselectedText;\n    opacity: 0.55;\n  }\n\n  &__number {\n    font-size: 1rem;\n    font-weight: 600;\n    color: $unselectedText;\n  }\n}\n","$white: #ffffff;\n$text_dark: #2c2c2e;\n$text_gray: rgb(178, 181, 188);\n$buttonBg: #363c56;\n$errorText: #f70d1a;\n$buttonLinearBg: linear-gradient(to right, #1d2239, #4657a2, #1d2239);\n$msgDisable: rgb(150, 150, 150);\n$disabled: rgb(200, 200, 200);\n$light_gray: rgb(241, 241, 241);\n$unselectedText: rgb(80, 80, 80);\n$locationBnt: rgb(255, 255, 0);\n$spinner_blue: #3498db;\n\n$bg_unselected: rgb(188, 188, 224);\n$bg_selected: #559f5b;\n$bg_pending: #ccb137;\n$bg_frame: rgba(0, 0, 0, 0.6);\n\n$shadow: #2c2c2e5e;\n$light_shadow: rgba(49, 49, 52, 0.2);\n$highlighter: #eeff6e;\n$appt_bg: rgb(249, 249, 249);\n$red_bg: #cb101a;\n\n$notification_success: #4fae00;\n$notification_warning: #e4dd00;\n$notification_error: #be1000;\n","@mixin click-animation() {\n  &:active:not(:disabled) {\n    box-shadow: 0 0.125rem 0.5rem $buttonBg;\n    transform: translateY(0.125rem);\n    opacity: 0.75;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
